import { isVideoArticlePage } from '../../../utils/aem-utils';

export default {
  name: 'Carousel Inline',
  selector: '.carouselInline:not([data-initialized])',
  shouldInit: () => !isVideoArticlePage(), // Note: on video article template, this init will be handled by asyncVideoArticle
};
